module.exports = "//cdn.mxpnl.com/static/asset-cache/b68f11d140c468f1781e1f9e5c79b0cb/iron/common/widgets/intro/images/onboarding-shapes.svg";